<template>
  <div>
    <collapsible-section
        class="collapse-item"
        id="processFlowMetadataCollapse"
        control-name="processFlowMetadataCollapse"
        :is-open="false"
    >
      <template #section-header>
        {{ handler.header }}
      </template>

      <template #section-contents>
        <field-item
            v-for="datum in metadataSection.metadata"
            :key="datum.label"
            :disabled="handler.isDisabled(datum)"
            @click="select(handler.selectMetadata(datum))"
        >
          <row>
            <prefix>
              <icon :glyph="iconGlyph(datum)"/>
            </prefix>
            <column>
              {{ datum.label }}
            </column>
          </row>
        </field-item>
      </template>
    </collapsible-section>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import handlerComponentsMixin from "~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin";
import CollapsibleSection from './common/collapsible-section.vue';
import FieldItem from './common/field-item.vue';
import ProcessFlowMetadataHandler from "~/models/dynamicFields/handlers/processFlows/processFlowMetadataHandler";
import {IDynamicField} from "~/interfaces/dynamicFieldsInterfaces";
import {ReferenceNodeModelTypeMap} from "~/enums/referenceNodeType";

export default Vue.extend({
  mixins: [handlerComponentsMixin],
  components: {
    CollapsibleSection,
    FieldItem
  },
  props: {
    handler: {
      type: Object as () => ProcessFlowMetadataHandler,
      required: true,
    },
  },
  computed: {
    metadataSection() {
      return this.handler.metadataSection(this.lowerQ);
    },
  },
  methods: {
    iconGlyph(datum: IDynamicField) {
      return this.modelTypeIcon(ReferenceNodeModelTypeMap[Number(datum.id)]);
    },
  },
});
</script>